import React from 'react';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Calculator } from '@ratehub/base-ui';

import CreditCardInterestInputStep from './CreditCardInterestInputStep';


function CreditCardInterestCalculator({ ...otherProps }) {
    return (
        <Calculator
            className="rh-position-relative rh-max-width-50"
            title={(
                <FormattedMessage
                    id="calculators.CreditCardInterestCalculator.calculatorTitle"
                    defaultMessage="Ratehub.ca’s credit card interest calculator"
                />
            )}
            {...otherProps}
        >
            <CreditCardInterestInputStep
                stepNumber={1}
            />
        </Calculator>
    );
}


export default observer(CreditCardInterestCalculator);
